module.exports = __webpack_public_path__ + "img/speaker-ClarenceSeedorf-img.7ce71c98.png";